import UXCatTooltip from './UXCatTooltip';

export default UXCatTooltip;
